export const PhysicianQualifierCodeTypes = {
  ReferringPhysician: 'DN',
  OrderingPhysician: 'DK',
  SupervisingPhysician: 'DQ'
}

export const PhysicianQualifierDescription = {
  ReferringPhysician: 'Referring Physician',
  OrderingPhysician: 'Ordering Physician',
  SupervisingPhysician: 'Supervising Physician'
}